import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { useTranslation } from "react-i18next";
import cx from "classnames";
import MenuArrowIcon from "../../../../assets/svgs/menu-arrow-next.svg";

import Link from "../../../Link";

const LightSubMenu = ({ setMenuPage, mainMenu, contents }) => {
  const { t } = useTranslation();

  const Content = ({ mainMenu: _mainMenu, subMenus: _subMenus = [] }) => (
    <>
      <div className="d-flex mt-2 mb-4">
        <span className="title text-capitalize">
          {_mainMenu} {_subMenus.length > 0 && `(${_subMenus.length})`}
        </span>
      </div>

      {contents.header && (
        <Link
          className={cx("px-0 mt-1 mb-4 col-md-6", {
            disabled: contents.header.disabled,
          })}
          to={contents.header.to}
        >
          <div className="d-flex align-items-center mb-2">
            <h5 className="mb-0">{t(`menu.${mainMenu}.content.title`)}</h5>
            {contents.header.isInProgress ? (
              <div className="badge ml-2 py-1 px-2">COMING SOON</div>
            ) : (
              <MenuArrowIcon className="ml-2" />
            )}
          </div>
          <span
            dangerouslySetInnerHTML={{
              __html: t(`menu.${mainMenu}.content.description`),
            }}
          />
        </Link>
      )}

      {_subMenus.map((subMenu, i) => (
        <Link
          key={`main-menu__${subMenu.title}-${i}`}
          className="px-0 mt-1 mb-4"
          to={subMenu.to}
        >
          <div className="d-flex align-items-center mb-1">
            <h5>{t(`menu.${mainMenu}.${subMenu.title}`)}</h5>
            <MenuArrowIcon className="mb-2 ml-2" />
          </div>
        </Link>
      ))}
    </>
  );

  return (
    <div className="mobile-menu d-flex flex-column justify-content-between h-100">
      <div className="container">
        <div className="d-flex flex-column mt-3 w-100">
          <button
            className="mobile-menu__back-btn d-flex btn btn-back px-0 pt-0 pb-3"
            onClick={() => setMenuPage(null)}
          >
            <StaticImage
              imgClassName="back"
              src={"../../../../assets/images/icons/arrow-icon.png"}
              alt="back"
              width={16}
              height={16}
              placeholder="blurred"
            />
          </button>

          <Content mainMenu={mainMenu} subMenus={contents.subMenus} />

          {contents.additionalSubMenus && (
            <>
              <div className="border-top mt-3 mb-5" />
              <Content
                mainMenu={"updates"}
                subMenus={contents.additionalSubMenus}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default LightSubMenu;
